import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

class OtherPrivateController extends Controller {
	public constructor() {
		super({ requestUrl: "models/outerPrivate/" });
	}

	/**@POST START SPY MODE */
	public async startSpyModeAsync({ token }: IRequestConfig) {
		return this.post<void>("start", null, { token });
	}

	/**@DELETE STOP SPY MODE */
	public async stopSpyModeAsync({ token }: IRequestConfig) {
		return this.delete<void>("stop", { token });
	}
}

export const otherPrivateAPI = new OtherPrivateController();
